(function () {
  'use strict';

  var bar = document.querySelector('[data-gef-cd-sticky-mobile]');
  if (!bar) return;

  document.body.classList.add('gef-cd-has-sticky-mobile');

  var pdpRoot = document.querySelector('[data-pdp-root]');
  var vatMultiplier = pdpRoot ? parseFloat(pdpRoot.getAttribute('data-pdp-vat-multiplier')) : 1.22;
  if (!vatMultiplier || vatMultiplier < 1) vatMultiplier = 1.22;

  var cta = bar.querySelector('[data-sticky-cta]');
  var mainForm = document.querySelector('#gef-cd-pdp-form') ||
    document.querySelector('form[action*="/cart/add"]');
  var pricehead = document.querySelector('[data-bulk-pricehead]') ||
    document.querySelector('.gef-cd-pdp__cta-row') ||
    document.querySelector('.gef-cd-pdp__info');
  var shouldBeVisible = false;
  var lastY = window.scrollY || 0;
  var ticking = false;

  function setVisible(vis) {
    shouldBeVisible = !!vis;
    bar.setAttribute('aria-hidden', shouldBeVisible ? 'false' : 'true');
    bar.classList.toggle('is-visible', shouldBeVisible);
  }

  function setDirectionState() {
    var y = window.scrollY || 0;
    lastY = y;
    if (!shouldBeVisible) return;
    if (y > 160) bar.classList.remove('is-hidden-by-scroll');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      setDirectionState();
    });
  }

  if ('IntersectionObserver' in window && pricehead) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setVisible(!entry.isIntersecting);
        if (entry.isIntersecting) bar.classList.remove('is-hidden-by-scroll');
      });
    }, { rootMargin: '-96px 0px -42% 0px', threshold: 0.01 }).observe(pricehead);
  } else {
    setVisible(true);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  function syncCtaQuoteState(isQuote) {
    if (!cta) return;
    cta.classList.toggle('is-quote', !!isQuote);
    cta.setAttribute('data-quote-active', isQuote ? 'true' : 'false');
    cta.setAttribute('aria-label', isQuote ? 'Richiedi preventivo' : 'Aggiungi al carrello');
    cta.textContent = isQuote ? 'Preventivo' : 'Aggiungi';
  }

  if (cta && mainForm) {
    cta.addEventListener('click', function (event) {
      event.preventDefault();
      if (cta.disabled) return;
      if (cta.getAttribute('data-quote-active') === 'true') {
        var quoteHref = cta.getAttribute('data-quote-href');
        if (quoteHref) window.location.href = quoteHref;
        return;
      }
      if (typeof mainForm.requestSubmit === 'function') {
        mainForm.requestSubmit();
      } else {
        mainForm.submit();
      }
    });
  }

  var bulk = document.querySelector('[data-gef-cd-bulk]');
  var stickyPrice = bar.querySelector('[data-bulk-sticky-price]');

  function formatEuro(value) {
    return '&euro;' + (Number(value) || 0).toFixed(2).replace('.', ',');
  }

  function renderStickyPrice(excl, incl) {
    if (!stickyPrice) return;
    stickyPrice.innerHTML = formatEuro(excl) +
      ' <span class="gef-cd-muted">IVA escl.</span>' +
      '<small class="gef-cd-sticky-mobile__price-sub">' + formatEuro(incl) + ' IVA incl.</small>';
  }

  if (bulk && stickyPrice) {
    bulk.addEventListener('gef:bulk:change', function (event) {
      var detail = event.detail || {};
      if (detail.quote) {
        stickyPrice.innerHTML = '<span class="gef-cd-muted">Su preventivo</span>';
        syncCtaQuoteState(true);
        return;
      }
      var unit = parseFloat(detail.unit) || 0;
      var boxes = parseInt(detail.boxes, 10) || 1;
      var total = unit * boxes;
      var totalIncl = total * vatMultiplier;
      renderStickyPrice(total, totalIncl);
      syncCtaQuoteState(false);
    });
  }

  window.addEventListener('gef:pdp:variant-change', function (event) {
    var detail = event.detail || {};
    if (cta && cta.getAttribute('data-quote-active') !== 'true') {
      var available = !!detail.available;
      cta.disabled = !available;
      cta.setAttribute('aria-disabled', available ? 'false' : 'true');
      cta.setAttribute('aria-label', available ? 'Aggiungi al carrello' : 'Non disponibile');
      cta.textContent = available ? 'Aggiungi' : 'N/D';
    }
    if (stickyPrice && detail.price && (!cta || cta.getAttribute('data-quote-active') !== 'true')) {
      var gross = detail.price / 100;
      renderStickyPrice(gross / vatMultiplier, gross);
    }
  });
})();
